import { ActionOutboxEntityType } from 'src/WebApiController';

/** Query param carrying the PlaceholderEventGroup id on the group details page routes. */
export const groupIdSearchParam = 'groupId';

export const INVENTORY_PLACEHOLDER_GROUP_PATH = '/inventory/placeholder-group';
export const PURCHASE_PLACEHOLDER_GROUP_PATH = '/purchases/placeholder-group';

/**
 * Builds the placeholder event group details URL for the given context: the inventory variant
 * (listing tiles) for Listing, the purchase variant (ticket group tiles) otherwise.
 */
export const createPlaceholderEventGroupUrl = (
  entityType: ActionOutboxEntityType,
  groupId: string
): string => {
  const base =
    entityType === ActionOutboxEntityType.Listing
      ? INVENTORY_PLACEHOLDER_GROUP_PATH
      : PURCHASE_PLACEHOLDER_GROUP_PATH;
  return `${base}?${groupIdSearchParam}=${groupId}`;
};
